import * as React from 'react'

export const Avatar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={12} fill="rgba(225, 36, 104, 1)" />
    <path
      d="M17.333 18v-1.333A2.667 2.667 0 0 0 14.667 14H9.332a2.667 2.667 0 0 0-2.667 2.667V18M12 11.333A2.667 2.667 0 1 0 12 6a2.667 2.667 0 0 0 0 5.333Z"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
